import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryProvider, RouterProvider } from './providers';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <QueryProvider>
        <RouterProvider />
      </QueryProvider>
    </HelmetProvider>
  );
};

export default App;